
import { Vue, Component, Ref } from 'vue-property-decorator';
import { VForm } from '@/features/common/types';
import CommentItem from '@/features/shipment-history/components/details/comments/CommentItem.vue';
import { HistoryCommentType } from '@/features/shipment-history/types';
import { requiredRules } from '@/features/common/helpers/validationRules';

@Component({
  components: {
    CommentItem,
  },
})
export default class Comments extends Vue {
  @Ref('form') form!: VForm;

  private requiredRules = requiredRules;

  private commentValue = '';

  private comments: HistoryCommentType[] = [
    {
      username: 'Mike Jansen',
      text: 'I have contacted the carrier @SandyAlhuwalia. They ensured me that the shipment will be delivered on time.',
      date: '2022-03-09',
      id: '2204283940128409128408',
    },
  ];

  get myName(): string {
    return this.$store.getters.getUserInfo.fullName;
  }

  private async postComment(): Promise<void> {
    const isValid = this.form.validate();

    if (!isValid) {
      return;
    }

    const comment = {
      username: this.myName,
      text: this.commentValue,
      date: new Date().toISOString(),
      isMy: true,
      id: Date.now().toString(),
    };

    this.comments.push(comment);

    (this.$refs.form as HTMLFormElement).resetValidation();
    this.commentValue = '';

    await this.$nextTick();
    const commentsElements: Vue[] = this.$refs.comments as Vue[];
    const lastComment = commentsElements[commentsElements.length - 1].$el;
    lastComment.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }

  private deleteComment(id: string): void {
    const comment = this.comments.find((c) => c.id === id);
    const idx = this.comments.indexOf(comment as HistoryCommentType);

    if (!comment) return;

    this.comments.splice(idx, 1);
  }
}
